import authService from "../services/auth.service";

/**
 * Attach the caller's identity to a DDS preset.
 *
 * Ported from Aether (BB_AdminPanelUI/src/dds/withAuthContext.js) deliberately
 * unchanged — both apps are filtered by the same org allowlist through the same
 * DDS code path, so they must not drift in how they identify themselves.
 *
 * org_id scopes the competitions list to what this organization is entitled to.
 * DDS reads the org document's competitions[] and filters server-side (see
 * BB_DataDistributionService/src/modules/query/resolver.service.js), so
 * disallowed competitions never reach the browser. It lives on the session
 * object rather than inside the access token, which carries no org claim.
 *
 * Note this attaches the org to the getStaticData (PRESET) path only, which is
 * the only DDS path this file feeds. searchData is org-scoped too as of OPUS-92,
 * but it takes the org as its own `org_id` GraphQL argument rather than through
 * a preset context — see BB_AdminPanelUI/src/dds/searchData.js. This app's one
 * searchData call reads `fixture`, which DDS does not scope (it carries no
 * competition_id in contexts[]), so it is unaffected either way.
 *
 * Both fields are stripped server-side before any DWS query is built (token in
 * query.resolvers.js, org_id in resolver.service.js), so neither can ever act
 * as a row filter — adding this to a preset cannot change which rows come back
 * for any collection other than the competition list.
 */
export function withAuthContext(preset) {
  const accessKey = authService.getAccessKey();
  const orgId = authService.getSession()?.orgId || null;
  return {
    ...preset,
    context: {
      ...(preset?.context || {}),
      token: accessKey ? `Bearer ${accessKey}` : null,
      ...(orgId ? { org_id: orgId } : {}),
    },
  };
}
